import React from 'react';

const PortfolioView = () => (
  <div className="flex flex-col h-full p-6">
    <h1 className="text-2xl font-bold mb-6">My Portfolio</h1>
    
    <div className="bg-white rounded-lg shadow-md mb-6">
      <div className="p-6 border-b border-gray-200">
        <h2 className="text-xl font-semibold mb-2">Portfolio Summary</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-sm text-gray-600">Total Value</p>
            <p className="text-2xl font-bold text-blue-700">$128,450.00</p>
            <p className="text-xs text-green-600 mt-1">+2.4% today</p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-sm text-gray-600">Models Deployed</p>
            <p className="text-2xl font-bold text-blue-700">7</p>
            <p className="text-xs text-blue-600 mt-1">3 active, 4 paused</p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-sm text-gray-600">Monthly Return</p>
            <p className="text-2xl font-bold text-blue-700">+5.6%</p>
            <p className="text-xs text-green-600 mt-1">+1.2% vs benchmark</p>
          </div>
        </div>
      </div>
      
      <div className="p-6">
        <h3 className="font-medium mb-4">Recent Activity</h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center pb-2 border-b border-gray-100">
            <div>
              <p className="font-medium">Algo Trading Model #3</p>
              <p className="text-sm text-gray-500">Position increased</p>
            </div>
            <div className="text-right">
              <p className="font-medium text-green-600">+$1,240.00</p>
              <p className="text-xs text-gray-500">Today, 2:34 PM</p>
            </div>
          </div>
          <div className="flex justify-between items-center pb-2 border-b border-gray-100">
            <div>
              <p className="font-medium">Risk Assessment Model</p>
              <p className="text-sm text-gray-500">Alert triggered</p>
            </div>
            <div className="text-right">
              <p className="font-medium text-yellow-600">Review needed</p>
              <p className="text-xs text-gray-500">Today, 11:20 AM</p>
            </div>
          </div>
          <div className="flex justify-between items-center pb-2 border-b border-gray-100">
            <div>
              <p className="font-medium">Market Sentiment Analyzer</p>
              <p className="text-sm text-gray-500">Model rebalanced</p>
            </div>
            <div className="text-right">
              <p className="font-medium text-blue-600">Auto adjustment</p>
              <p className="text-xs text-gray-500">Yesterday, 4:15 PM</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div className="flex justify-end">
      <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
        View Full Portfolio
      </button>
    </div>
  </div>
);

export default PortfolioView; 